/*
  FYNDMAXA: ordförslag i sökrutan.
  Shopify ger inga ordförslag på svenska, så vi lägger in egna i temats "Förslag"-lista.
  Orden kommer från assets/fm-sokord.json (byggs från produkttitlar, produkttyper och taggar,
  mest använda ord först). Produktförslagen från Shopify ligger kvar som förut.
*/
(() => {
  // Snippet:en kan renderas flera gånger på samma sida, kör bara en gång
  if (window.fmSokforslagStarted) return;
  window.fmSokforslagStarted = true;
  const wordsUrl = window.fmSokordUrl;
  if (!wordsUrl) return;

  customElements.whenDefined('predictive-search').then(() => setup(customElements.get('predictive-search')));

  function setup(PredictiveSearch) {
    const MAX = 8;
    let words = null;
    let loading = null;

    const loadWords = () =>
      (loading ||= fetch(wordsUrl)
        .then((r) => r.json())
        .then((data) => (words = data))
        .catch(() => (words = [])));

    const normalize = (s) => s.toLowerCase().replace(/\s+/g, ' ').trim();

    // Först ord som börjar som det man skrivit, sedan fraser där ett senare ord gör det,
    // sist sammansatta ord där det står inuti ("spegel" hittar "sminkspegel")
    function suggest(query) {
      const q = normalize(query);
      if (!q || !words) return [];
      const starts = [];
      const wordStarts = [];
      const inside = [];
      for (const w of words) {
        if (w.startsWith(q)) starts.push(w);
        else if (w.includes(' ' + q)) wordStarts.push(w);
        else if (q.length >= 3 && w.includes(q)) inside.push(w);
        if (starts.length >= MAX) break;
      }
      return starts.concat(wordStarts, inside).slice(0, MAX);
    }

    // Var i ordet träffen sitter, för att kunna markera den
    function matchAt(word, q) {
      if (word.startsWith(q)) return 0;
      const atWord = word.indexOf(' ' + q);
      return atWord >= 0 ? atWord + 1 : word.indexOf(q);
    }

    function buildItem(word, query, index) {
      const searchUrl = (window.routes?.search_url || '/search') + '?q=' + encodeURIComponent(word) + '&options%5Bprefix%5D=last';
      const li = document.createElement('li');
      li.id = 'fm-sokforslag-' + index;
      li.className = 'predictive-search__list-item';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');

      const a = document.createElement('a');
      a.href = searchUrl;
      a.className = 'predictive-search__item link link--text';
      a.tabIndex = -1;

      const content = document.createElement('div');
      content.className = 'predictive-search__item-content predictive-search__item-content--centered';

      // Temat visar det man skrivit i <mark> (tunnare) och resten i fetstil
      const p = document.createElement('p');
      p.className = 'predictive-search__item-heading predictive-search__item-query-result h5';
      p.setAttribute('aria-label', word);
      const q = normalize(query);
      const at = matchAt(word, q);
      const mark = document.createElement('mark');
      mark.textContent = word.slice(at, at + q.length);
      const before = document.createElement('span');
      before.textContent = word.slice(0, at);
      const after = document.createElement('span');
      after.textContent = word.slice(at + q.length);
      p.append(before, mark, after);

      content.append(p);
      a.append(content);
      li.append(a);
      return li;
    }

    function getOrCreateList(root) {
      const existing = root.querySelector('#predictive-search-results-queries-list');
      if (existing) return existing;

      const results = root.querySelector('#predictive-search-results');
      if (!results) return null;

      let wrapper = results.querySelector('#predictive-search-results-groups-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.id = 'predictive-search-results-groups-wrapper';
        wrapper.className = 'predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-products';
        results.prepend(wrapper);
      }
      wrapper.classList.remove('predictive-search__results-groups-wrapper--no-suggestions');

      let group = wrapper.querySelector('.predictive-search__result-group');
      const hasFirstColumn = group && !group.querySelector('#predictive-search-results-products-list');
      if (!hasFirstColumn) {
        group = document.createElement('div');
        group.className = 'predictive-search__result-group';
        wrapper.prepend(group);
      }

      const block = document.createElement('div');
      const heading = document.createElement('h2');
      heading.id = 'predictive-search-queries';
      heading.className = 'predictive-search__heading text-body caption-with-letter-spacing';
      heading.textContent = 'Förslag';
      const list = document.createElement('ul');
      list.id = 'predictive-search-results-queries-list';
      list.className = 'predictive-search__results-list list-unstyled';
      list.setAttribute('role', 'group');
      list.setAttribute('aria-labelledby', 'predictive-search-queries');
      block.append(heading, list);
      group.prepend(block);
      return list;
    }

    function addSuggestions(root, query) {
      if (root.getQuery() !== query) return; // användaren har hunnit skriva vidare
      const found = suggest(query);
      if (!found.length) return;
      const list = getOrCreateList(root);
      if (!list) return;
      list.querySelectorAll('[id^="predictive-search-option-query-"]').forEach((el) => el.remove());
      list.prepend(...found.map((word, i) => buildItem(word, query, i + 1)));
    }

    const originalRender = PredictiveSearch.prototype.renderSearchResults;
    PredictiveSearch.prototype.renderSearchResults = function (markup) {
      originalRender.call(this, markup);
      const query = this.getQuery();
      loadWords().then(() => addSuggestions(this, query));
    };

    // Hämta ordlistan redan när någon klickar i sökrutan, så att första förslaget kommer direkt
    document.addEventListener('focusin', (e) => {
      if (e.target.closest?.('predictive-search')) loadWords();
    });
  }
})();
